import * as React from "react";
function ChevronRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.364 22a.345.345 0 01-.272-.14.46.46 0 01.03-.588L16.274 12l-9.15-9.27a.461.461 0 01-.032-.59c.07-.088.169-.14.273-.14a.34.34 0 01.24.104l9.152 9.272c.021.022.04.043.059.067.268.346.241.875-.058 1.18l-9.152 9.273a.338.338 0 01-.241.104z"
  }));
}
const ForwardRef = React.forwardRef(ChevronRightIcon);
export default ForwardRef;